 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "../../js/" + ({"apply-details":"apply-details","apply-finished":"apply-finished","apply-membership":"apply-membership","apply-router":"apply-router","apply-validation":"apply-validation","auth":"auth","invitation":"invitation","community-apply":"community-apply","event-backstage~event-live-stage~room":"event-backstage~event-live-stage~room","event-backstage~event-live-stage":"event-backstage~event-live-stage","event-live-stage":"event-live-stage","event-backstage~member-single":"event-backstage~member-single","event-backstage":"event-backstage","room":"room","member-single":"member-single","event-live":"event-live","event-live-manual-login":"event-live-manual-login","event-live-networking~networking":"event-live-networking~networking","event-live-networking":"event-live-networking","networking":"networking","event-live-partners":"event-live-partners","event-live-schedule":"event-live-schedule","event-magic-link":"event-magic-link","events-video":"events-video","membership":"membership","nft":"nft","team-page":"team-page","test-page":"test-page"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"apply-details":1,"apply-finished":1,"apply-membership":1,"apply-validation":1,"auth":1,"chunk-049e573a":1,"chunk-087fef3d":1,"invitation":1,"chunk-09529f33":1,"chunk-15fbc50d":1,"chunk-17fe00b4":1,"chunk-37504e5d":1,"chunk-37f61b12":1,"chunk-54581d4a":1,"chunk-69112d4e":1,"chunk-6ad82be6":1,"chunk-7311dc4e":1,"chunk-7927155c":1,"chunk-7e505321":1,"chunk-cf271eee":1,"chunk-dd3cfad6":1,"community-apply":1,"event-backstage~event-live-stage~room":1,"event-backstage~event-live-stage":1,"event-live-stage":1,"event-backstage~member-single":1,"event-backstage":1,"room":1,"member-single":1,"event-live":1,"event-live-manual-login":1,"event-live-networking~networking":1,"event-live-networking":1,"networking":1,"event-live-partners":1,"event-live-schedule":1,"event-magic-link":1,"events-video":1,"membership":1,"nft":1,"team-page":1,"test-page":1,"chunk-01410187":1,"chunk-04313c8a":1,"chunk-04a3aa73":1,"chunk-069d82c6":1,"chunk-0772960a":1,"chunk-0b166878":1,"chunk-4306dd80":1,"chunk-7484d866":1,"chunk-110b8528":1,"chunk-33234d38":1,"chunk-468404df":1,"chunk-6e9da88c":1,"chunk-0a3e8231":1,"chunk-0d3a582b":1,"chunk-0f16beb2":1,"chunk-0f773495":1,"chunk-115675d3":1,"chunk-1241a859":1,"chunk-134bb5b9":1,"chunk-14dce8bd":1,"chunk-1d75a780":1,"chunk-1de45e7a":1,"chunk-23f950d9":1,"chunk-25c011f4":1,"chunk-27ac78c6":1,"chunk-2a66ea77":1,"chunk-2a68075a":1,"chunk-2f3ecf30":1,"chunk-300989a7":1,"chunk-379c951a":1,"chunk-388ef27c":1,"chunk-39307346":1,"chunk-3fab01c0":1,"chunk-41464c49":1,"chunk-43168011":1,"chunk-4972f303":1,"chunk-4a689c3c":1,"chunk-4ae65226":1,"chunk-4dca7c7f":1,"chunk-5546bb55":1,"chunk-5623de89":1,"chunk-57b4e862":1,"chunk-5d4a84dc":1,"chunk-5dae4a92":1,"chunk-61ca6d65":1,"chunk-61cf6d48":1,"chunk-6282abee":1,"chunk-634aa386":1,"chunk-65987ee5":1,"chunk-66376a06":1,"chunk-6650c7cc":1,"chunk-68482565":1,"chunk-6a7b175e":1,"chunk-6aa65e08":1,"chunk-6fb3b9c0":1,"chunk-72364b69":1,"chunk-7428a195":1,"chunk-78b606c6":1,"chunk-7ce33f1a":1,"chunk-7dc8a4c0":1,"chunk-827afae6":1,"chunk-84df6d4a":1,"chunk-84e5db98":1,"chunk-86ec8a4e":1,"chunk-93349406":1,"chunk-9b3e3e60":1,"chunk-ac0b8b96":1,"chunk-b6cc3e2c":1,"chunk-c60fc218":1,"chunk-c78ebf4a":1,"chunk-cca5f2ca":1,"chunk-ccec3fc0":1,"chunk-ce3f865a":1,"chunk-d5960d5a":1,"chunk-d65defbc":1,"chunk-d82c0346":1,"chunk-e21af91a":1,"chunk-e3af9812":1,"chunk-e4e99dae":1,"chunk-e50056e2":1,"chunk-f1188a40":1,"chunk-f35e4afc":1,"chunk-fb189836":1,"chunk-72a7c880":1,"chunk-7536cb43":1,"chunk-ed5babc8":1,"chunk-a9ef9964":1,"chunk-146d675a":1,"chunk-5b9acd8e":1,"chunk-ca1b9084":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "../../css/" + ({"apply-details":"apply-details","apply-finished":"apply-finished","apply-membership":"apply-membership","apply-router":"apply-router","apply-validation":"apply-validation","auth":"auth","invitation":"invitation","community-apply":"community-apply","event-backstage~event-live-stage~room":"event-backstage~event-live-stage~room","event-backstage~event-live-stage":"event-backstage~event-live-stage","event-live-stage":"event-live-stage","event-backstage~member-single":"event-backstage~member-single","event-backstage":"event-backstage","room":"room","member-single":"member-single","event-live":"event-live","event-live-manual-login":"event-live-manual-login","event-live-networking~networking":"event-live-networking~networking","event-live-networking":"event-live-networking","networking":"networking","event-live-partners":"event-live-partners","event-live-schedule":"event-live-schedule","event-magic-link":"event-magic-link","events-video":"events-video","membership":"membership","nft":"nft","team-page":"team-page","test-page":"test-page"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cf-assets.frenchfounders.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
